import { useRtoasterRecommendWithCache } from "@/hooks";
import RtRecommendSlider from "@/components/Rtoaster/RtRecommendSlider";
import config from "@/lib/config";
/**
 * WatchRecommend.
 *
 * watchページ用のRtoasterレコメンド
 *
 * @returns {React.ReactElement}
 */
export default function WatchRecommend() {
  const elementIds = [
    config.rtoasterElementId.watch.related,
    config.rtoasterElementId.watch.recommend,
  ];

  const { loading } = useRtoasterRecommendWithCache(elementIds);

  if (loading) return null;

  return (
    <>
      <RtRecommendSlider
        header={{ text: "関連作品" }}
        elementId={config.rtoasterElementId.watch.related}
      />
      <RtRecommendSlider
        header={{ text: "あなたにおすすめの作品" }}
        elementId={config.rtoasterElementId.watch.recommend}
      />
    </>
  );
}
